export enum WorkOrderTypeColumns {
    work_order_type_id = 'work_order_type_id',
    code = 'code',
    name = 'name',
    sequence = 'sequence',
    active = 'active',
    data = 'data',
}

export interface WorkOrderTypeAttributes {
    work_order_type_id: number;
    code: string;
    name: string;
    sequence: number;
    active: boolean;
    data: any | null;
}

export type WorkOrderTypeOptionalAttributes = 'work_order_type_id' | 'sequence' | 'active' | 'data';

export interface WorkOrderTypeCreate {
    work_order_type_id?: number;
    code: string;
    name: string;
    sequence?: number;
    active?: boolean;
    data?: any | null;
}
